/**
 * @author: lv.chen3
 * @desc: Pipeline/ProjectList页面 下载表单弹窗
 * @date: 2025/2/8
 */
import React from 'react';
import classnames from 'classnames';
import GeneralModal from '@gp/components/GeneralModal';
import DownloadBox from '../DownloadBox';
import useDownload from '../../_hooks/useDownload';

import type { IBaseProps } from '@home/types/common';
import type { IRecord } from '@gp/types/global';

interface IDownloadModalProps extends IBaseProps {
  ppsViewable: boolean;
  updatesViewable: boolean;
  setIsDownloading: React.Dispatch<boolean>;
  downloadModalVisible: boolean;
  setDownloadModalVisible: React.Dispatch<boolean>;
  fetchParams: IRecord<any>;
}

const DownloadModal: React.FC<IDownloadModalProps> = (props) => {
  const {
    style,
    className,
    ppsViewable,
    updatesViewable,
    setIsDownloading,
    downloadModalVisible,
    setDownloadModalVisible,
    fetchParams,
  } = props;

  const { downloadModalRes, setDownloadModalRes, handleDownload } = useDownload({ fetchParams, setIsDownloading });

  return (
    <GeneralModal
      style={style}
      className={classnames('dbg-project-list-download-modal globalpedia-custom-scrollbar', className)}
      title="Download Settings"
      modalSize={1064}
      isFooter
      isFont14={false}
      visible={downloadModalVisible}
      disabledConfirm={
        !downloadModalRes ||
        ((!downloadModalRes?.projects || !downloadModalRes?.projects?.length) &&
          (!downloadModalRes?.projectDetail || !downloadModalRes?.projectDetail?.length) &&
          (!downloadModalRes?.latestGR || !downloadModalRes?.latestGR?.length) &&
          (!downloadModalRes?.stakeholder || !downloadModalRes?.stakeholder?.length) &&
          (!downloadModalRes?.tech || !downloadModalRes?.tech?.length))
      }
      onConfirm={() => {
        handleDownload();
        setDownloadModalVisible(false);
      }}
      onClose={() => {
        setDownloadModalVisible(false);
      }}
      content={
        <DownloadBox
          isPPSPermission={ppsViewable}
          isUpdatesPermission={updatesViewable}
          onChange={(payload) => {
            setDownloadModalRes(payload);
          }}
        />
      }
    />
  );
};

export default DownloadModal;
